export enum CostMethodEnum {
    last_purchase = 'COSTING_METHOD.LAST_PURCHASE_COST',
    moving_average = 'COSTING_METHOD.MOVING_AVERAGE',
}

export enum ColumnFieldClass {
    CUSTOM_PRICE = 'custom-price',
    CUSTOM_FLOAT = 'custom-float',
    CUSTOM_COUNT = 'custom-count',
    CUSTOM_PERCENTS = 'custom-percents',
    CUSTOM_TIME = 'custom-time',
    CUSTOM_TIME_INTERVAL = 'custom-time-interval',
    CUSTOM_TIME_PERIOD = 'custom-time-period',
    CUSTOM_XVI_PRICE = 'custom-xvi-price',
    CUSTOM_XVI_FLOAT = 'custom-xvi-float',
    CUSTOM_XVI_ARROW_PRICE = 'custom-xvi-arrow-price',
    CUSTOM_XVI_ARROW_FLOAT = 'custom-xvi-arrow-float',
    CUSTOM_XVI_RANGE_PRICE = 'custom-xvi-range-price',
    CUSTOM_XVI_RANGE_PERCENT = 'custom-xvi-range-percent',
    CUSTOM_XVI_NUMBER = 'custom-xvi-number',
    CUSTOM_XVI_DATE = 'custom-xvi-date',
    CUSTOM_DATE = 'custom-date',
    CUSTOM_DURATION = 'custom-duration',
    CUSTOM_XVI_SPECIFIC = 'custom-xvi-specific',
    CUSTOM_BUSINESS_DATE = 'custom-business-date',
    CUSTOM_STRING = 'custom-string',
}

export const ColumnFieldClassList: string[] = [
    ColumnFieldClass.CUSTOM_PRICE,
    ColumnFieldClass.CUSTOM_FLOAT,
    ColumnFieldClass.CUSTOM_COUNT,
    ColumnFieldClass.CUSTOM_PERCENTS,
    ColumnFieldClass.CUSTOM_TIME,
    ColumnFieldClass.CUSTOM_XVI_PRICE,
    ColumnFieldClass.CUSTOM_XVI_FLOAT,
    ColumnFieldClass.CUSTOM_XVI_ARROW_PRICE,
    ColumnFieldClass.CUSTOM_XVI_ARROW_FLOAT,
    ColumnFieldClass.CUSTOM_XVI_RANGE_PRICE,
    ColumnFieldClass.CUSTOM_XVI_RANGE_PERCENT,
    ColumnFieldClass.CUSTOM_XVI_NUMBER,
    ColumnFieldClass.CUSTOM_DATE,
    ColumnFieldClass.CUSTOM_DURATION,
];
